import { Box } from '@mui/material';
import React from 'react';

export const CreditCard = () => (
  <Box>
    <img src="ccard.png" alt="" />
  </Box>
);
